import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawAssignmentsCompleteIcon from "./RawAssignmentsCompleteIcon.svg.jsx";

const AssignmentsCompleteIcon = forwardRef((props, ref) => {
  return (
    <Icon ref={ref} SvgComponent={RawAssignmentsCompleteIcon} {...props} />
  );
});

export default AssignmentsCompleteIcon;
